import Grid2 from "@mui/material/Grid2";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";

// Fixed list: the work order types the plant uses, plus the "no filter" entry.
const TYPE_OPTIONS = [
	{ id: "PM", description: "PM" },
	{ id: "RM", description: "RM" },
	{ id: "A", description: "All types" },
];

type Props = {};

export const TypesFilter = ({}: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	const type = searchParams.get("type") ?? "A";

	const handleFilter = (e: any) => {
		searchParams.set("type", e.target.value);
		setSearchParams(searchParams, { replace: true });
	};

	return (
		<Box
			sx={{
				marginTop: "4px",
				"& .MuiSelect-select": {
					backgroundColor: "#FFF",
				},
			}}
		>
			<FormControl
				variant="outlined"
				size="small"
				sx={{
					width: "100%",
				}}
			>
				<InputLabel id="types-select-label" shrink>
					Types
				</InputLabel>
				<Select
					labelId="types-select-label"
					id="types-select"
					value={type}
					onChange={handleFilter}
					label="Types"
					notched
				>
					{TYPE_OPTIONS.map((type) => {
						return (
							<MenuItem key={`logId-${type.id}`} value={type.id}>
								<Grid2 container alignItems="center">
									{type.description}
								</Grid2>
							</MenuItem>
						);
					})}
				</Select>
			</FormControl>
		</Box>
	);
};
